(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GenerateListAction',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		let actionVal = $('.action-select').val();

		if (actionVal.length > 0) {
			_handleFields(actionVal);
		}

		$('.action-select').change(function actionSelected() {
			$('#labels-container').addClass('hidden');
			$('#list-container').addClass('hidden');
			$('#agents-container').addClass('hidden');
			$('#sources-container').addClass('hidden');
			$('#maxx-email-container').addClass('hidden');
			$('#segment-container').addClass('hidden');

			$('.submit-container').addClass('hidden');
			$('.action-submit').html('Submit');

			_handleFields($(this).val());

		});

		$('.action-submit').click(function actionSubmitClicked() {
			if ($('.action-select').val() === 'cppod') {
				$('form-loader').css('visibility', 'visible');
			} else {
				$('form-loader').css('visibility', 'hidden');
			}

			if ($('.action-select').val() === 'delete_clients') {
				Adzuki.CustomConfirm({
						body   : 'You are choosing to DELETE the selected client profiles from your CP Maxx client database. This action CANNOT be undone. Are you sure you wish to continue?',
						confirm: function submitForm() {
							$('#list-action').submit();
						},
				});
			} else {
				$('#list-action').submit();
			}

		});

		$('body').on('check-all-done', function checkAllClicked(event, checked) {
			var count = 0;
			if (checked) {
				count = $('.mychecks').length;
			}
			$('.generate-list-select-count').html(count);
		});

		$('.countem').click(function checkAllClicked() {
			var total_checked = 0;

			$('.mychecks').each(function countChecks() {
				if ($(this).prop('checked') === true) {
					total_checked++;
				}
			});

			$('.generate-list-select-count').html(parseFloat(total_checked));
		});

		$('#client-list-loading').addClass('hidden');
		$('#client-list-review-box').removeClass('hidden');
	};

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		location.href = response.data;
	};

	function _handleFields(actionVal) {
		switch (actionVal) {
			case 'export':
				$('.submit-container').removeClass('hidden');
				break;
			case 'labels':
				$('#labels-container').removeClass('hidden');
				$('.submit-container').removeClass('hidden');
				break;
			case 'cppod':
				$('#list-container').removeClass('hidden');
				$('.submit-container').removeClass('hidden');
				break;
			case 'maxx_email':
				$('#maxx-email-container').removeClass('hidden');
				$('.submit-container').removeClass('hidden');
				break;
			case 'reassign':
				$('#agents-container').removeClass('hidden');
				$('.submit-container').removeClass('hidden');
				break;
			case 'cohorts_queue':
				$('.submit-container').removeClass('hidden');
				break;
			case 'source':
				$('#sources-container').removeClass('hidden');
				$('.submit-container').removeClass('hidden');
				break;
			case 'delete_clients':
				$('.action-submit').html('Continue');
				$('.submit-container').removeClass('hidden');
				break;
			case 'segment':
					$('#segment-container').removeClass('hidden');
					$('.submit-container').removeClass('hidden');
					break;
			case '':
			default:
				break;
		}
	}

}(jQuery, window.Adzuki || {}));